





























import { ButtonType } from '@getaccept/lib-ui';
import { RecipientStatus } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-status';
import { throttle } from '@getaccept/lib-shared/src/helpers';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from '@vue/composition-api';
import { watch, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    document: { type: Object as PropType<SigningPageDocument>, required: true },
    sender: { type: Object as PropType<SigningPageUser>, required: true },
    recipient: { type: Object as PropType<SigningPageRecipient>, required: true },
    authId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const approved = () => {
      if (props.recipient.status === RecipientStatus.Approved) {
        handleClose();
      }
    };
    watch(() => props.recipient.status, approved);

    const handleClose = () => {
      emit('close');
    };
    const emitApprove = () => {
      emit('approve');
    };
    const handleApprove = throttle(emitApprove, 1000);

    return {
      handleClose,
      handleApprove,
      ButtonType,
      approved,
    };
  },
});
